module.exports = ".custom-checkbox.select-all {\n  margin-right: -10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/orders/orders.component.scss
// module id = ./src/app/account-client/component/account-client-details/orders/orders.component.scss
// module chunks = main